import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { authReturnDestination } from '../auth/authReturn';

export default function GuestRoute() {
  const { status } = useAuth();
  const location = useLocation();
  if (status === 'authenticated') {
    return <Navigate to={authReturnDestination(location.state?.from)} replace />;
  }
  return <Outlet />;
}
